export var AppDefinitionId;
(function (AppDefinitionId) {
    AppDefinitionId["About"] = "14dbef06-cc42-5583-32a7-3abd44da4908";
    AppDefinitionId["MyAccount"] = "14cffd81-5215-0a7f-22f8-074b0e2401fb";
    AppDefinitionId["Members"] = "14dbefd2-01b4-fb61-32a7-3abd44da4908";
    AppDefinitionId["Blog"] = "14bcded7-0066-7c35-14d7-466cb3f09103";
    AppDefinitionId["FileShare"] = "1537b24e-29d1-6d8f-b8e1-d6860f2f70b9";
    AppDefinitionId["Followers"] = "14ebe801-d78a-daa9-c9e5-0286a891e46f";
    AppDefinitionId["Forum"] = "14724f35-6794-cd1a-0244-25fd138f9242";
    AppDefinitionId["Addresses"] = "1505b775-e885-eb1b-b665-1e485d9bf90e";
    AppDefinitionId["Bookings"] = "13d21c63-b5ec-5912-8397-c3a5ddb27a97";
    AppDefinitionId["Events"] = "140603ad-af8d-84a5-2c80-a0f60cb47351";
    AppDefinitionId["Stores"] = "1380b703-ce81-ff05-f115-39571d94dfcd";
    AppDefinitionId["Wallet"] = "4aebd0cb-fbdb-4da7-b5d1-d05660a30172";
    AppDefinitionId["Notifications"] = "14f25924-5664-31b2-9568-f9c5ed98c9b1";
    AppDefinitionId["Settings"] = "14f25dc5-6af3-5420-9568-f9c5ed98c9b1";
    AppDefinitionId["SharedGallery"] = "476dc2dd-e16e-43b0-a0aa-1a486c78fbe2";
    AppDefinitionId["Subscriptions"] = "2bef2abe-7abe-43da-889c-53c1500a328c";
    AppDefinitionId["ProfilePageBob"] = "b976560c-3122-4351-878f-453f337b7245";
    AppDefinitionId["Programs"] = "2936472a-a1ed-4ae5-9f71-614313a9f4e7";
    AppDefinitionId["Rewards"] = "16ed1ac6-01cb-4fb6-a59e-c215cce8fdf6";
    AppDefinitionId["Groups"] = "148c2287-c669-d849-d153-463c7486a694";
    AppDefinitionId["TestVertical"] = "567d5e7e-4224-4488-a24b-d1ee5f691e54";
    AppDefinitionId["ContributorProfile"] = "f9694946-7e53-4ab4-9cc7-21d275993d39";
})(AppDefinitionId || (AppDefinitionId = {}));
//# sourceMappingURL=app-definition.js.map